import { getSnowplowEventPayload, logAnalyticsEvent } from '../analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from '../analytics.const';

const { SITEWIDE_BANNER } = ANALYTICS_CATEGORIES;

export const triggerSitewideBannerLoadEvent = (bannerId: string): void => {
	const eventPayload = getSnowplowEventPayload({
		category: SITEWIDE_BANNER,
		customData: { label: bannerId },
		name: 'banner_displayed',
		schemaName: SNOWPLOW_EVENTS.LOAD.SCHEMA,
		version: SNOWPLOW_EVENTS.LOAD.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerSitewideBannerLinkClickEvent = (bannerId: string): void => {
	const eventPayload = getSnowplowEventPayload({
		category: SITEWIDE_BANNER,
		customData: { label: bannerId },
		name: 'banner_feature_click',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
